export default  {
    "PLACE": {
        "PLACE": "Location",
        "NAME": "Name",
        "CITY": "City",
        "CITIES": "Cities",
        "LOCATION": "Position",
        "ADDRESS": "Address",
        "DESCRIPTION": "Description",
        "ADDRESS_SEARCH": "Address search",
        "MARKER_POS": "Marker position (y,x)",
        "MARKER_COLOR": "Marker color",
        "MARKER_DIR": "Marker direction",
        "TYPE": "Type",
    }
}


// WEBPACK FOOTER //
// ./src/i18n/messages/en/place.js